import Redirect from "./auth/Redirect";
import AuthGuard from "./auth/AuthGuard";
import NotFound from "./views/sessions/NotFound";
import sessionRoutes from "./views/sessions/session-routes";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import dashboardRoutes from "./views/dashboard/dashboard-routes";
import usersetupRoute from "./views/usersetup/usersetup-routes";
import organizationRoute from "./views/organization/organization-routes";
import loanstatusRoute from "./views/loanstatus/loanstatus-routes";
import borrowerTypeRoute from "./views/borrowerType/borrowerType-routes";
import loanfundRoute from "./views/loanfund/loanfund-routes";
import loantypeRoute from "./views/loantype/loantype-route";
import GLCodeRoute from "./views/GLCode/GLCode-routes";
import collateraltypeRoute from "./views/collateraltype/collateraltype-route";
import elementcodeRoute from "./views/elementcode/elementcode-routes";
import zoningRoute from "./views/zoning/zoning-route";
import loanofficerRoute from "./views/loanofficer/loanofficer-route";
import optmasterfieldRoute from "./views/optmasterfields/optmasterfield-routes";
import supplementInstallationRoute from "./views/SupplementInstallation/SupplementInstallation-routes";
import loanmasternewRoute from "./views/loanmasternew/loanmaster-routes";
import borrowerinfoRoute from "./views/borrowerinfo/borrowerinfo-routes";
import companyinfoRoute from "./views/companyinfo/companyinfo-routes";
import loanmasterviewRoute from "./views/loanmasterview/loanmasterview-routes";
import loanactivityRoute from "./views/loanactivity/loanactivity-routes";
import ReportsRoute from "./views/reports/routes/ReportsRoute";
import SupplementsRoute from "./views/supplements/routes/SupplementsRoute";
import AmortizationsRoute from "./views/amortizations/routes/AmortizationsRoute";
import auditorSetupRoute from "./views/auditorsetup/auditorsetup-routes";
import form1098SetupRoute from "./views/form1098setup/form1098setup-routes";
import prepare1098Route from "./views/prepare1098/prepare1098-routes";
import directDepositRoute from "./views/supplements/routes/directdeposit-routes";
import DirectDepositReportsRoutes from './views/directdepositreports/routes/directdepositreports-routes';

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...usersetupRoute,
      ...organizationRoute,
      ...loanstatusRoute,
      ...borrowerTypeRoute,
      ...loanfundRoute,
      ...elementcodeRoute,
      ...loantypeRoute,
      ...GLCodeRoute,
      ...collateraltypeRoute,
      ...zoningRoute,
      ...loanofficerRoute,
      ...optmasterfieldRoute,
      ...supplementInstallationRoute,
      ...loanmasternewRoute,
      ...borrowerinfoRoute,
      ...companyinfoRoute,
      ...loanmasterviewRoute,
      ...loanactivityRoute,
      ...ReportsRoute,
      ...SupplementsRoute,
      ...AmortizationsRoute,
      ...auditorSetupRoute,
      ...form1098SetupRoute,
      ...prepare1098Route,
      ...directDepositRoute,
    ]
  },
  ...DirectDepositReportsRoutes,
  ...sessionRoutes,
  { path: "/", element: <Redirect /> },
  { path: "*", element: <NotFound /> }
];

export default routes;
